<template>
    <div>
        <v-row>
            <v-col cols="12" sm="12">
                <v-checkbox color="primary" v-model="booking.isPdr" label="Is PDR?" />
                <v-text-field v-if="booking.isPdr" v-model="booking.pdrAmount" label="PDR Amount" />
                <v-checkbox color="primary" v-model="booking.isAlloys" label="Is Alloys?" />
                <v-text-field v-if="booking.isAlloys" v-model="booking.alloysAmount" label="Alloys Amount" />
                <v-checkbox v-if="booking.isAlloys" v-model="booking.alloyTypes" value="PC" color="primary" label="PC" />
                <v-checkbox v-if="booking.isAlloys" v-model="booking.alloyTypes" value="DC" color="primary" label="DC" />
                <v-checkbox v-if="booking.isAlloys" v-model="booking.alloyTypes" value="CCH" color="primary" label="CCH" />
                <v-checkbox v-if="booking.isAlloys" v-model="booking.alloyTypes" value="CR" color="primary" label="CR"></v-checkbox>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        name: "RsContractors",
        props: {
            booking: Object
        }
    }
</script>

<style scoped>

</style>
